import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCustomerTypeList(params) {
  return request({
    url: URL.mdm.basicData.customerType,
    method: 'get',
    params
  })
}

export function saveCustomerType(data) {
  return request({
    url: URL.mdm.basicData.customerType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCustomerType(uuid) {
  return request({
    url: URL.mdm.basicData.customerType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
